import PersonalCapsuleEvaluationItemList from "../PersonalCapsuleEvaluationItemList/personalCapsuleEvaluationItemList";
import { useEffect, useState } from "react";
import { appAxiosInstance } from "../../../api";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { PaginationControl } from "react-bootstrap-pagination-control";
import s from './personalCapsuleEvaluationList.module.css';
import {
    IPersonalCapsuleEvaluation, IPersonalCapsuleRequestParams, IPersonalCapsuleResponse
} from '../types';
import { Loader } from "../../../components/Loader/loader";

export default function PersonalCapsuleEvaluationList() {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [allItems, setAllItems] = useState(0);
    const [dateBegin, setDateBegin] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const [personalCapsuleEvaluation, setPersonalCapsuleEvaluation] = useState<IPersonalCapsuleEvaluation[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getEvaluation = async () => {

        try {
            setIsLoading(true);
            const params: IPersonalCapsuleRequestParams = {
                currentPage: currentPage,
                itemsPerPage: itemsPerPage,
                dateBegin: dateBegin || null,
                dateEnd: dateEnd || null
            }

            const evaluationResponse = await appAxiosInstance.get<IPersonalCapsuleResponse>('mobile/assistant/personalCapsule/feedback', { params });
            const evaluationList = evaluationResponse.data;

            if (evaluationList?.countRecords) {
                setPersonalCapsuleEvaluation(evaluationList.items);
                setAllItems(evaluationList.countRecords || 0);
            } else {
                setPersonalCapsuleEvaluation([]);
                setAllItems(0);
            }
        } catch (error) {
            toast.error(`Ошибка при получении оценок образов`);
            setPersonalCapsuleEvaluation([]);
            setAllItems(0);
        } finally {
            setIsLoading(false);
        }
    };

    const paginate = (pageNumbers: number) => {
        setCurrentPage(pageNumbers);
    }

    const find = () => {
        getEvaluation();
    }

    const cleanForm = () => {
        setDateBegin('');
        setDateEnd('');
    }

    useEffect(() => {
        getEvaluation();
    }, [currentPage, dateBegin, dateEnd]);

    return (

        <div>
            <div className={s.filterBlock}>
                <div className={s.dateBlock}>
                    <div className={s.headerName}>Дата начала</div>
                    <input
                        value={dateBegin}
                        type="date"
                        onChange={e => setDateBegin(e.target.value)}
                        placeholder="Введите дату начала для фильтрации"
                        className={s.filterClothesFormUp}
                    />
                </div>
                <div className={s.dateBlock}>
                    <div className={s.headerName}>Дата окончания</div>
                    <input
                        value={dateEnd}
                        type="date"
                        onChange={e => setDateEnd(e.target.value)}
                        placeholder="Введите дату начала для фильтрации"
                        className={s.filterClothesFormUp}
                    />
                </div>
                <Button type="button" className={s.searchFormButton} onClick={find}>Поиск</Button>
                <Button type="button" className={s.searchFormButton} onClick={cleanForm}>Сбросить фильтр</Button>
            </div>

            {isLoading ? (
                <div className={s.loadingContainer}>
                    <Loader/>
                </div>
                ) : (
                <div>
                    {personalCapsuleEvaluation && personalCapsuleEvaluation.length > 0 ? (
                    personalCapsuleEvaluation.map((evaluation, index) => (
                        <PersonalCapsuleEvaluationItemList key={`image-${index}`} evaluation={evaluation} />
                    ))
                    ) : (
                    <div className={s.emptyState}>
                        <h3 className={s.emptyStateTitle}>Оценки не найдены</h3>
                    </div>
                    )}
                </div>
            )}

            <PaginationControl
                page={currentPage}
                between={4}
                total={allItems}
                limit={itemsPerPage}
                changePage={(page) => {
                    paginate(page)
                }}
                ellipsis={1}
            />
        </div>
    );
}